import React from 'react';

import Button from '@atlaskit/button';
import DropdownMenu from '@atlaskit/dropdown-menu';
import HipchatChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';

import { ExecutionStatus, TestExecutionStep } from '@qality/common-model';
import { StatusUtils, StatusesGroup } from '@qality/common-utils';

import { ExecutionStatusSelectOptions } from '../select/execution-status-select/ExecutionStatusSelect/ExecutionStatusSelectOptions';
import './_test-case-table.scss';

type Props = {
  testSteps: Array<TestExecutionStep>;
  statuses: Array<ExecutionStatus>;
  onBulkUpdateTestStep: (testSteps: Array<TestExecutionStep>) => Promise<void>;
  numberOfSelectedItems: number;
};

const GroupStatusSelect: React.FC<Props> = (groupStatusSelectProps: Props) => (
  <DropdownMenu
    trigger={({ triggerRef, ...props }) => (
      <Button
        {...props}
        iconAfter={<HipchatChevronDownIcon label='dropdown`s trigger' />}
        ref={triggerRef}
      >
        {`(${groupStatusSelectProps.numberOfSelectedItems}) Status`}
      </Button>
    )}
  >
    <DropDownData
      data={StatusUtils.groupStatusesByCategoryWithoutMapping(
        groupStatusSelectProps.statuses
      )}
      {...groupStatusSelectProps}
    />
  </DropdownMenu>
);

type DropDownDataProps = {
  testSteps: Array<TestExecutionStep>;
  onBulkUpdateTestStep: (arg) => void;
  data: StatusesGroup;
};

function DropDownData(props: DropDownDataProps) {
  const onClick = (status: ExecutionStatus) => {
    const testSteps = [];
    props.testSteps.forEach((testStep, testStepIndex) => {
      if (testStep.isSelected) {
        testStep.status = status;
        testSteps.push({
          index: testStepIndex,
          testStep,
        });
      }
    });
    props.onBulkUpdateTestStep(testSteps);
  };

  return (
    <ExecutionStatusSelectOptions
      statusesCategories={props.data}
      onClick={onClick}
    />
  );
}

export default GroupStatusSelect;
